import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const MOBILE_BREAKPOINT = 641;

export const Main = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) {
    return (
      <div className="flex w-full min-h-screen mt-10 px-6 text-center">
        <p className="text-lg text-white">
          For the best experience, please view this site on a larger screen. Some features may not
          display correctly on mobile devices. Please try again on a tablet or desktop.
        </p>
      </div>
    );
  }

  return (
    <div className="w-full">
      <main className="mx-6 py-4">
        <div className="flex min-w-0">
          <div className="flex-1 min-w-0 overflow-scroll">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
};
